import { useGetOffer } from 'legacy/events/hooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdPause } from 'react-icons/io';
import { FaCirclePlay } from 'react-icons/fa6';
import OfferDetailsHeader from '../../offers/offer-details/OfferDetailsHeader';
import OfferDetailsStats from '../../offers/offer-details/OfferDetailsStats';
import PromoterCard from '../../offers/PromoterCard';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import { OffersStep } from 'legacy/events/offers.types';
import EditPromoterStatusModal from '../../offers/modals/EditPromoterStatusModal';
import OfferDetailsSkeleton from '../../offers/offer-details/OfferDetailsSkeleton';

const OfferDetailPage = ({
  offerId,
  setOffersStep
}: {
  offerId: string;
  setOffersStep: (step: OffersStep) => void;
}) => {
  const { t } = useTranslation(['events']);
  const { data, isLoading } = useGetOffer(offerId, { enabled: !!offerId });
  const contracts = data?.contracts;
  const [isPausePromoterModalOpen, setIsPausePromoterModalOpen] =
    useState(false);

  const handleEditOffer = () => {
    setOffersStep(OffersStep.EDIT_OFFER);
  };

  if (isLoading || !data) {
    return <OfferDetailsSkeleton />;
  }

  return (
    <>
      <FadeIn>
        <div className="pt-[36x] md:pt-[90px] -mt-[36px] pb-20 md:w-[630px] md:mx-auto md:px-0 px-4">
          <OfferDetailsHeader data={data} />
          <div
            className={`flex mt-4 items-center justify-center gap-2 border border-[#EFF2FF] rounded-2xl p-2 ${
              !data?.isActive ? 'bg-[#EFF2FF]' : ''
            }`}
            onClick={() => setIsPausePromoterModalOpen(true)}
          >
            <div className="text-sm font-bold text-[#3853C4]">
              {data?.isActive ? t('settings.promoterOffers.page.pauseOffer') : t('settings.promoterOffers.page.resumeOffer')}
            </div>
            {data?.isActive ? (
              <IoMdPause className="text-[#3853C4]" />
            ) : (
              <FaCirclePlay className="text-[#3853C4]" />
            )}
          </div>
          <OfferDetailsStats data={data} />
          {contracts?.length > 0 && (
            <div className="mt-10">
              <div className="text-base font-bold text-[#202020] mb-4">
                {t('settings.promoterOffers.page.promoters')} ({contracts?.length})
              </div>
              <div className="mt-4">
                {contracts?.map((contract) => (
                  <PromoterCard
                    key={contract.id}
                    contract={contract}
                    eventId={data?.eventId}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </FadeIn>
      <div
        className="w-full bg-white fixed bottom-0 left-0 p-4 z-10 border-t pb-12 md:pb-4"
        onClick={handleEditOffer}
      >
        <div className="w-full md:w-[343px] mx-auto">
          <div className="flex gap-4">
            <Button type={ButtonType.Primary} onClick={() => null}>
              <div className="flex items-center justify-center">{t('settings.promoterOffers.page.editOfferButton')}</div>
            </Button>
          </div>
        </div>
      </div>
      {isPausePromoterModalOpen && (
        <EditPromoterStatusModal
          onClose={() => setIsPausePromoterModalOpen((prev) => !prev)}
          eventId={data?.eventId}
          offerId={data?.id}
          isActive={data?.isActive}
          onSuccess={() => {
            setIsPausePromoterModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default OfferDetailPage;
